// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-footer-lets-chat----lets-chat-module---wrapper---QxhL6","title":"src-components-footer-lets-chat----lets-chat-module---title---2OeU9","link":"src-components-footer-lets-chat----lets-chat-module---link---1zfn5","award":"src-components-footer-lets-chat----lets-chat-module---award---3CnO0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/lets-chat/lets-chat.module.css
// module id = 165
// module chunks = 35783957827783 114276838955818